import { UniversalFilterConfig } from "../../components/Filters/ReportFilter";

/**
 * 📄 Anexo Consumidor Final
 *
 * Reporte:
 * Reportes Fiscales / Hacienda
 *
 * Filtros:
 * - Sucursal
 * - Fecha Desde
 * - Fecha Hasta
 *
 * Backend esperado:
 * - branchId
 * - dateFrom
 * - dateTo
 */
export const finalConsumerAnnexReportFilters: UniversalFilterConfig[] = [
  {
    name: "branchId",
    label: "Sucursal",
    type: "select",
    iconKey: "branch",
  },
  {
    name: "dateFrom",
    label: "Fecha Desde",
    type: "date",
    iconKey: "calendar",
  },
  {
    name: "dateTo",
    label: "Fecha Hasta",
    type: "date",
    iconKey: "calendar",
  },
];